<template>
  <div>
    <b-form-checkbox
      id="select-all-menu-event-permissions"
      v-model="allSelected"
      name="select-all-menu-event-permissions"
      class="text-capitalize mt-2"
      switch
    >
      {{ $t('hanwha_dvr.groups_permissions.select_all') }}
    </b-form-checkbox>
    <b-list-group>
      <b-list-group-item>
        <div class="row">
          <div
            v-for="(option, index) in eventOptions"
            :key="index"
            class="col-6"
          >
            <b-form-checkbox
              :id="`option-${index}`"
              v-model="itemData.EventMenuAccess"
              :name="`option-${index}`"
              class="mt-1 text-capitalize"
              switch
              :value="option.value"
            >
              {{ option.label }}
            </b-form-checkbox>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { useArraySelectAllSwitch, flattenOptionValues } from "./useSelectAllSwitch";

export default {
  props: {
    itemData: {
      type: Object
    }
  },
  setup (props) {
    //COMPOSABLES
    const { t } = useI18nUtils();

    //DATA
    const eventOptions = [
      {
        label: t('hanwha_dvr.groups_permissions.menu.event.nvr_sensor_detection'),
        value: 'NvrSensorDetection'
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.event.event_setup'),
        value: 'NvrEventSetup'
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.event.onvif_event'),
        value: 'OnvifEvent'
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.event.event_rule'),
        value: 'EventRule'
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.event.event_schedule'),
        value: 'EventSchedule'
      }
    ];

    const { allSelected } = useArraySelectAllSwitch(
      props.itemData,
      "EventMenuAccess",
      flattenOptionValues(eventOptions)
    );

    return { allSelected, eventOptions }
  }
}
</script>
